
export default {
  methods: {
    async fetchCardknoxCardToken() {
      return new Promise((resolve) => {
        this.$refs.cardknoxTemplate.$refs.ifieldCardRef._onToken = (response) => {
          this.cardToken = response?.data?.xToken || ""
          resolve(this.cardToken)
        }
        this.$refs.cardknoxTemplate.$refs.ifieldCardRef.getToken()
      })
    },
  },
}